/** Signup window includes 2–8 November UTC. Every member gets seven
 * complete days from signup, even if their access ends after enrollment. */
export const TESTER_CAMPAIGN_ID = "novari-test-2026-11";
export const TESTER_SIGNUP_START = Date.parse("2026-11-02T00:00:00Z");
export const TESTER_SIGNUP_END = Date.parse("2026-11-09T00:00:00Z");
export const TESTER_TRIAL_DAYS = 7;
export const STANDARD_TRIAL_MAX_DAYS = 14;
const DAY_MS = 86_400_000;
export type TesterTier = "starter" | "plus" | "max";
export interface TesterTrial {
  campaignId: string;
  tier: TesterTier;
  joinedAt: string;
  endsAt: string;
  active: boolean;
}

/** A server-generated random auth UUID gives a stable random allocation.
 * No user-supplied plan, mutable profile date, or refresh counter is used. */
export function testerTrialForSignup(id: string, createdAt: unknown, now = Date.now()): TesterTrial | null {
  if (!/^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(id) || typeof createdAt !== "string") return null;
  const joined = Date.parse(createdAt);
  if (!Number.isFinite(joined) || joined < TESTER_SIGNUP_START || joined >= TESTER_SIGNUP_END) return null;
  let hash = 2166136261;
  for (const char of TESTER_CAMPAIGN_ID + ":" + id.toLowerCase()) {
    hash = Math.imul(hash ^ char.charCodeAt(0), 16777619) >>> 0;
  }
  const bucket = hash % 100;
  const tier: TesterTier = bucket < 50 ? "starter" : bucket < 90 ? "plus" : "max";
  const ends = joined + TESTER_TRIAL_DAYS * DAY_MS;
  return { campaignId: TESTER_CAMPAIGN_ID, tier,
    joinedAt: new Date(joined).toISOString(), endsAt: new Date(ends).toISOString(),
    active: joined <= now && now < ends };
}

export function withTesterTier(base: TesterTier, trial: TesterTrial | null): TesterTier {
  if (!trial?.active) return base;
  const rank: Record<TesterTier, number> = { starter: 0, plus: 1, max: 2 };
  return rank[trial.tier] > rank[base] ? trial.tier : base;
}
